/*
 * Copyright (c) 2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import OutputList from "../OutputList/OutputList.jsx";
import OutputListItem from "../OutputList/OutputListItem.jsx";
import DateTime from "toolbox/dateTime";
import useBuildServer from "../../hooks/useBuildServer.jsx";

const BuildServerSettings = ({buildServerId}) => {
    const buildServerInfo = useBuildServer(buildServerId)

    return (
        <OutputList>
            <OutputListItem titel={"BuildServer Id"}>
                <span>{buildServerInfo.indexKey}</span>
            </OutputListItem>
            <OutputListItem titel={"Name"}>
                <span>{buildServerInfo.name}</span>
            </OutputListItem>
            <OutputListItem titel={"Domain"}>
                <span>{buildServerInfo.buildServerDomain}</span>
            </OutputListItem>
            <OutputListItem titel={"Server Id"}>
                <span>{buildServerInfo.serverId}</span>
            </OutputListItem>
            <OutputListItem titel={"IPv4"}>
                <span>{buildServerInfo.ipv4}</span>
            </OutputListItem>
            <OutputListItem titel={"SSH Port"}>
                <span>{buildServerInfo.sshPort}</span>
            </OutputListItem>
            <OutputListItem titel={"Region"}>
                <span>{buildServerInfo.region}</span>
            </OutputListItem>
            <OutputListItem titel={"Status"}>
                <span>{buildServerInfo.status}</span>
            </OutputListItem>
            <OutputListItem titel={"SV"}>
                <span>{buildServerInfo.SV}</span>
            </OutputListItem>
            <OutputListItem titel={"creationTime"}>
                <span>{DateTime.format(buildServerInfo.creationTime, "HH:mm dd.MM.yyyy")}</span>
            </OutputListItem>
        </OutputList>
    );
}

export default BuildServerSettings;